var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.8,
    fill: "white",
    stroke: "#625E5E",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0222 17.6556C14.6222 20.8 17.2 23.3778 20.3444 24.9778L22.7889 22.5333C23.1 22.2222 23.5333 22.1333 23.9222 22.2556C25.1667 22.6667 26.5 22.8889 27.8889 22.8889C28.1836 22.8889 28.4662 23.006 28.6746 23.2143C28.8829 23.4227 29 23.7053 29 24V27.8889C29 28.1836 28.8829 28.4662 28.6746 28.6746C28.4662 28.8829 28.1836 29 27.8889 29C22.8792 29 18.0748 27.0099 14.5324 23.4676C10.9901 19.9252 9 15.1208 9 10.1111C9 9.81643 9.11706 9.53381 9.32544 9.32544C9.53381 9.11706 9.81643 9 10.1111 9H14C14.2947 9 14.5773 9.11706 14.7857 9.32544C14.994 9.53381 15.1111 9.81643 15.1111 10.1111C15.1111 11.5 15.3333 12.8333 15.7444 14.0778C15.8667 14.4667 15.7778 14.9 15.4667 15.2111L13.0222 17.6556Z",
    fill: "#625E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCall);
export default __webpack_public_path__ + "static/media/ic_call.6fa8308c50fdadb9e05bc7b97283e0a6.svg";
export { ForwardRef as ReactComponent };